// Configuração de ambiente para o CoffeeIn Institutional
// Este arquivo usa variáveis de ambiente definidas no .env

const environmentConfig = {
  // URLs base da API
  api: {
    development: {
      baseURL: process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:5000/api',
      timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
      retryAttempts: parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3,
      retryDelay: parseInt(process.env.REACT_APP_API_RETRY_DELAY) || 1000
    },
    production: {
      baseURL: process.env.REACT_APP_API_BASE_URL_PROD || 'https://api.coffeein.club/api',
      timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
      retryAttempts: parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3,
      retryDelay: parseInt(process.env.REACT_APP_API_RETRY_DELAY) || 1000
    }
  },
  
  // Endpoints da API
  endpoints: {
    companyInterest: '/api/interestSubmission/company',
    coffeeShopInterest: '/api/interestSubmission/coffee-shop'
  },
  
  // Configurações do frontend
  frontend: {
    url: process.env.REACT_APP_FRONTEND_URL || 'https://coffeein.club',
    title: process.env.REACT_APP_FRONTEND_TITLE || 'CoffeeIn Club - Institutional'
  },
  
  // Configurações do Cloudflare Turnstile - Chave Única para o Site
  turnstile: {
    // IMPORTANTE: Esta chave deve ser EXATAMENTE igual à configurada no backend
    // Chave de teste do Cloudflare (para desenvolvimento)
    siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || (process.env.NODE_ENV === 'production' ? '' : '1x0000000000000000000AA'),
    // Configurações do widget
    widget: {
      theme: 'light',
      size: 'normal',
      language: 'pt-BR'
    }
  },
  
  // Configurações de validação
  validation: {
    emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phoneRegex: /^[1-9][\d]{0,15}$/,
    minNameLength: parseInt(process.env.REACT_APP_MIN_NAME_LENGTH) || 2,
    maxNameLength: parseInt(process.env.REACT_APP_MAX_NAME_LENGTH) || 100,
    maxMessageLength: parseInt(process.env.REACT_APP_MAX_MESSAGE_LENGTH) || 1000
  },
  
  // Mensagens de feedback
  messages: {
    success: {
      company: 'Interesse empresarial registrado com sucesso! Nossa equipe comercial entrará em contato em breve.',
      coffeeShop: 'Interesse da cafeteria registrado com sucesso! Entraremos em contato em breve.'
    },
    error: {
      validation: 'Por favor, corrija os erros no formulário.',
      network: 'Erro de conexão. Verifique sua internet e tente novamente.',
      timeout: 'Tempo limite excedido. Tente novamente.',
      server: 'Erro no servidor. Tente novamente mais tarde.',
      unknown: 'Erro inesperado. Tente novamente.',
      turnstile: 'Por favor, complete a verificação de segurança.'
    },
    loading: {
      submitting: 'Enviando...',
      pleaseWait: 'Por favor, aguarde...'
    }
  }
};

// Determina o ambiente atual
const getCurrentEnvironment = () => {
  // Em produção, você pode usar variáveis de ambiente
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  return 'development';
};

// Exporta a configuração do ambiente atual
export const config = environmentConfig;
export const currentEnv = getCurrentEnvironment();
export const apiConfig = environmentConfig.api[currentEnv];

// Função para obter URL completa de um endpoint
export const getApiUrl = (endpoint) => {
  return `${apiConfig.baseURL.replace(/\/$/, '')}${endpoint}`;
};

// Função para obter configuração específica
export const getConfig = (path) => {
  return path.split('.').reduce((obj, key) => obj?.[key], environmentConfig);
};


export default environmentConfig;
